import React, { useState, useEffect } from "react";
// import axios from "axios";
import axios from "../../api/axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { Delete, Trash2Icon } from "lucide-react";
import { Link } from "react-router-dom";

const Certificatesissued = () => {
  const [allCertificates, setAllCertificates] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteData, setDeleteData] = useState(null);

  const isAdmin =
    localStorage.getItem("certificaterole") === "certificateadmin";

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    axios
      .get(`certificate`)
      .then((response) => {
        // console.log("response⚠️⚠️⚠️⚠️⚠️⚠️⚠️⚠️", response);
        const filtered = response.data.result.filter(
          (item) => item.cname && item.cname.trim() !== ""
        );

        const sorted = filtered.sort((a, b) => {
          // Sort descending: newest first
          return new Date(b.issued) - new Date(a.issued);
        });
        setAllCertificates(sorted);
        setSearchResults(sorted);
      })
      .catch((error) => console.error("API call error:", error));
  }, []);

  const performSearch = (value) => {
    setSearchTerm(value);
    if (!value.trim()) {
      setSearchResults(allCertificates);
    } else {
      const filtered = allCertificates.filter(
        (c) =>
          c.cname.toLowerCase().includes(value.toLowerCase()) ||
          c.id.toLowerCase().includes(value.toLowerCase()) ||
          c.coursename.toLowerCase().includes(value.toLowerCase())
      );
      setSearchResults(filtered);
    }
  };

  const confirmDeleteCertificate = (certificateId) => {
    setDeleteData(certificateId);
    setShowConfirm(true);
  };

  const handleDeleteCertificate = () => {
    if (!deleteData) return;

    axios
      .delete("certificate/" + deleteData)
      .then((response) => {
        if (response.data.success) {
          const updatedList = allCertificates.filter(
            (item) => item.id !== deleteData
          );
          setAllCertificates(updatedList);
          setSearchResults(updatedList);
          setSnackbar({
            open: true,
            message: `Certificate with ID ${response.data.id} Deleted Successfully`,
            severity: "success",
          });
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        setSnackbar({
          open: true,
          message: "Certificate Delete Failed",
          severity: "error",
        });
      })
      .finally(() => {
        setDeleteData(null);
        setShowConfirm(false);
      });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  // const handleRowClick = (id) => {
  //   const certUrl = `${process.env.REACT_APP_CERT_URL}${id}/`;
  //   window.open(certUrl, '_blank', 'noopener,noreferrer');
  // };

  return (
    <div style={{ padding: "15px" }}>
      {/* Search Input */}
      <TextField
        label="Search by Name or ID"
        value={searchTerm}
        onChange={(e) => performSearch(e.target.value)}
        variant="outlined"
        fullWidth
        size="small"
        // margin="normal"
        sx={{ my: 1, mb: 2 }}
      />

      {/* Certificates Table */}
      <TableContainer component={Paper}>
        <Table
          sx={{
            "& .MuiTableRow-root": {
              height: "50px !important", // force override default MUI height
            },
            "& .MuiTableCell-root": {
              paddingTop: "4px !important",
              paddingBottom: "4px !important",
              fontSize: "0.9rem",
            },
          }}
        >
          <TableHead sx={{ backgroundColor: "#d2d2d2" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Sl No</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Certificate ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Course Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Date of Issue</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searchResults.length > 0 &&
              searchResults.map((item, index) => (
                <TableRow
                  key={index}
                  hover
                  sx={{ cursor: "pointer" }}
                  //  onClick={() => handleRowClick(item.id)}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.cname}</TableCell>
                  <TableCell>
                    <Link
                      to={`${process.env.REACT_APP_CERT_URL}${item.id}/`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.id}
                    </Link>
                  </TableCell>
                  <TableCell>{item.coursename}</TableCell>
                  <TableCell>
                    {item.issued
                      ? item.issued
                          .substring(0, 10)
                          .split("-")
                          .reverse()
                          .join("-")
                      : ""}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      disabled={!isAdmin}
                      color="error"
                      onClick={() =>
                        isAdmin && confirmDeleteCertificate(item.id)
                      }
                    >
                      <Trash2Icon size={20} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Confirm Delete Dialog */}
      <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want to delete this <b>Certificate</b>? This action
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCertificate} color="error">
            Yes
          </Button>
          <Button onClick={() => setShowConfirm(false)} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="standard"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Certificatesissued;

///// THIS IS MUI TABLE WITH GRID FILTERS IN-BUILT BUT TO WORK ON PAGINATION

// import React, { useState, useEffect } from 'react';
// import axios from "../../api/axios";
// import {
//   Box,
//   TextField,
//   IconButton,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Button,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import { Trash2Icon } from "lucide-react";
// import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
// import { Link } from "react-router-dom";

// const Certificatesissued = () => {
//   const [allCertificates, setAllCertificates] = useState([]);
//   const [searchResults, setSearchResults] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [showConfirm, setShowConfirm] = useState(false);
//   const [deleteData, setDeleteData] = useState(null);

//   const isAdmin = localStorage.getItem("certificaterole") === "certificateadmin";

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   useEffect(() => {
//     axios
//       .get(`certificate`)
//       .then((response) => {
//         const filtered = response.data.result.filter(
//           (item) => item.cname && item.cname.trim() !== ""
//         );
//         const sorted = filtered.sort((a, b) => new Date(b.issued) - new Date(a.issued));
//         setAllCertificates(sorted);
//         setSearchResults(sorted);
//       })
//       .catch((error) => console.error('API call error:', error));
//   }, []);

//   const performSearch = (value) => {
//     setSearchTerm(value);
//     if (!value.trim()) {
//       setSearchResults(allCertificates);
//     } else {
//       const filtered = allCertificates.filter(
//         (c) =>
//           c.cname.toLowerCase().includes(value.toLowerCase()) ||
//           c.id.toLowerCase().includes(value.toLowerCase())
//       );
//       setSearchResults(filtered);
//     }
//   };

//   const confirmDeleteCertificate = (certificateId) => {
//     setDeleteData(certificateId);
//     setShowConfirm(true);
//   };

//   const handleDeleteCertificate = () => {
//     if (!deleteData) return;

//     axios
//       .delete("certificate/" + deleteData)
//       .then((response) => {
//         if (response.data.success) {
//           const updatedList = allCertificates.filter(item => item.id !== deleteData);
//           setAllCertificates(updatedList);
//           setSearchResults(updatedList);
//           setSnackbar({
//             open: true,
//             message: `Certificate with ID ${response.data.id} Deleted Successfully`,
//             severity: "success",
//           });
//         }
//       })
//       .catch((error) => {
//         console.error('API call error:', error);
//         setSnackbar({
//           open: true,
//           message: "Certificate Delete Failed",
//           severity: "error",
//         });
//       })
//       .finally(() => {
//         setDeleteData(null);
//         setShowConfirm(false);
//       });
//   };

//   const handleCloseSnackbar = (event, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Map certificates to rows with serial number
//   const rows = searchResults.map((cert, index) => ({
//     ...cert,
//     slNo: index + 1,
//     id: cert.id, // Ensure each row has a unique 'id' for DataGrid
//   }));

//   const columns = [
//     { field: 'slNo', headerName: 'Sl No', width: 90, sortable: false },
//     { field: 'cname', headerName: 'Name', flex: 1, minWidth: 150 },
//     {
//       field: 'id',
//       headerName: 'Certificate ID',
//       flex: 1,
//       minWidth: 150,
//       renderCell: (params) => (
//         <Link
//           to={`${process.env.REACT_APP_CERT_URL}${params.value}/`}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           {params.value}
//         </Link>
//       ),
//     },
//     { field: 'coursename', headerName: 'Course Name', flex: 1, minWidth: 150 },
//     {
//       field: 'issued',
//       headerName: 'Date of Issue',
//       width: 150,
//       renderCell: (params) => {
//         if (!params.value) return "";
//         const date = new Date(params.value);
//         return date.toLocaleDateString('en-GB', {
//           day: '2-digit',
//           month: 'short',
//           year: 'numeric',
//         });
//       },
//     },
//     {
//       field: 'actions',
//       type: 'actions',
//       headerName: 'Actions',
//       width: 80,
//       getActions: (params) => [
//         <GridActionsCellItem
//           icon={<Trash2Icon size={20} />}
//           label="Delete"
//           disabled={!isAdmin}
//           onClick={() => isAdmin && confirmDeleteCertificate(params.id)}
//         />,
//       ],
//     },
//   ];

//   console.log(">>>>>>", columns);
//   console.log(">>>>>>rowsssss", rows);
//   return (
//     <Box p={2}>
//       <TextField
//         label="Search by Name or ID"
//         value={searchTerm}
//         onChange={(e) => performSearch(e.target.value)}
//         variant="outlined"
//         fullWidth
//         size="small"
//         sx={{ mb: 2 }}
//       />

//       <Box sx={{ height: 500, width: '100%' }}>
//         <DataGrid
//           rows={rows}
//           columns={columns}
//           pageSize={10}
//           rowsPerPageOptions={[10, 25, 50]}
//           autoHeight
//           disableSelectionOnClick
//           sx={{
//             '& .MuiDataGrid-columnHeaders': { backgroundColor: '#d2d2d2', fontWeight: 'bold' },
//           }}
//         />
//       </Box>

//       <Dialog open={showConfirm} onClose={() => setShowConfirm(false)}>
//         <DialogTitle>Are you sure?</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Do you really want to delete this <b>Certificate</b>? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCertificate} color="error">
//             Yes
//           </Button>
//           <Button onClick={() => setShowConfirm(false)} color="primary">
//             Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           variant="standard"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default Certificatesissued;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////   PARTHAS CODE - DELETED  /////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// import React, { useState, useContext, useEffect } from 'react';
// import axios from "axios";

// import React, { useState, useContext, useEffect } from 'react';
// import axios from "axios";
// // import certificatepng from "./../../assets/images/cert.png";
// import Certificate from '../certificate/Certificate';
// import './Certificatesissued.css';
// import Text from '../../elements/text/Text';
// import { Trash2 } from "lucide-react";
// import Master from '../../utils/Master';
// import { Link } from "react-router-dom";

// const Certificatesissued = (props) => {
// //   const {
// //     apicalled,
// //     setapicalled
// //   } = useContext(Master);

//   const [showConfirm, setShowConfirm] = useState(false);
//   const [deleteData, setDeleteData] = useState(null);

//   const [allcertificates, setallcertificates] = useState([]);

//   const [uploaderror, setuploaderror] = useState();
//   const [searchresults, setsearchresults] = useState([]);
//   const [searchterm, setsearchterm] = useState('');

//   const isAdmin = (localStorage.getItem("certificaterole") === "certificateadmin");
//   // console.log("isAdmin", isAdmin);
// console.log("✅✅✅✅✅✅✅", allcertificates);
//   function performsearch(value) {
//     setsearchterm(value);
//     if (value.trim() === "") {
//       setsearchresults(allcertificates);
//     } else {
//       let tempsearchresults = JSON.parse(JSON.stringify(allcertificates));
//       console.log("tempsearchresults ✅✅✅✅✅", tempsearchresults);
//       tempsearchresults = tempsearchresults.filter((candidate) => ((candidate.cname.toLowerCase().includes(value.toLowerCase())) || (candidate.id.toLowerCase().includes(value.toLowerCase()))))
//       setsearchresults(tempsearchresults);
//     }

//   }

//   useEffect(() => {
//     axios
//       .get(process.env.REACT_APP_API_BASE+`certificates`)
//       .then((response) => {
//         console.log("response", response.data);

//         setsearchresults(response.data.result);
//         setallcertificates(response.data.result);
//         // console.log("allcertificates", response.data.result);
//       })
//       .catch((error) => {
//         console.error('API call error:', error);
//       });
//   }, [])

//   const confirmDeleteCertificate = (certificateid) => {
//     setDeleteData({ certificateid });
//     setShowConfirm(true);
//   }

//   const handleDeleteCertificate = () => {
//     if (!deleteData) return;
//       axios.delete(process.env.REACT_APP_API_BASE + "certificate/" + `${deleteData.certificateid}`, {
//       })
//             .then((response) => {
//                 if (response.data.success) {
//                     let newcertificatelist = allcertificates.filter((item) => item.id !== deleteData.certificateid);
//                     setallcertificates(newcertificatelist);
//                     setsearchresults(newcertificatelist);
//                 }
//             })
//             .catch((error) => {
//                 console.error('API call error:', error);
//             })
//             .finally(() => {
//                 setDeleteData(null);
//                 setShowConfirm(false);
//                 // setapicalled(!apicalled);
//             });
//     }

//   return (

//     <div className='Certificatesissued'>

//       <div className='searchbynameorid'>
//         <Text
//           label={"Search by Name or Id"}
//           update={performsearch}
//           value={searchterm}
//           required={true}
//           name={"iconame"}
//         />
//       </div>

//       <table className='tablemain'>
//         <thead className='headsection'>
//           <tr className='head'>
//             <th>Name</th>
//             <th>certificate ID</th>
//             <th>course Name</th>
//             <th>Date of Issue</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody className='body'>
//           {searchresults.length > 0 && <>
//             {searchresults?.map((item, i) => (
//               <tr key={i} className={1 % 2 == 0 ? 'even' : 'odd'}>
//                 <td>{item.cname}</td>
//                 <td>
//                   <a href={process.env.REACT_APP_CERT_URL + item.id + '/'}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {item.id}
//                 </a></td>
//                 <td>{item.coursename}</td>
//                 <td>{item.issued.substring(0, 10)}</td>
//                 <td>
//                   <Trash2
//                     color="red"
//                     size={20}
//                     style={{ cursor: isAdmin ? "pointer" : "not-allowed", opacity: !isAdmin ? 0.5 : 1 }}
//                     onClick={() => { if(isAdmin) confirmDeleteCertificate(item.id)}}
//                   />
//                 </td>
//               </tr>
//             ))}
//           </>
//           }
//         </tbody>
//       </table>

//             {/* Confirm Popup */}
//             <div>
//             {showConfirm && (
//                 <div className="popup-overlay">
//                     <div className="popup-box">
//                         <h3>Are you sure?</h3>
//                         <p>Do you really want to delete this <b>Certificate</b>. This Action can be <b>undone</b></p>
//                         <div className="popup-buttons">
//                         <button className="btn btn-danger" onClick={ handleDeleteCertificate }>
//                             Yes
//                         </button>
//                         <button
//                             className="btn btn-cancel"
//                             onClick={() => setShowConfirm(false)}
//                         >
//                             Cancel
//                         </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>

//     </div>
//   );
// };

// export default Certificatesissued;
